import { toast } from 'react-toastify';
import { waitDialog } from 'dialogs';
import type { CreateTarget } from 'actions';
import { getSchedulingWindow, type FetchedSchedulingWindow } from 'api/scheduling_windows/endpoints/getSchedulingWindow';
import SchedulingWindowModal from '../ModalSchedulingWindows';

export type ShowEditSchedulingWindowArgs =
  | { readonly mode: 'create'; readonly createIn?: CreateTarget }
  | { readonly mode: 'edit' | 'duplicate'; readonly id: number };

/**
 * Open the scheduling-window create / edit / duplicate modal and resolve when it
 * closes (so the caller can refresh). Standalone async: for edit/duplicate it
 * always fetches the record by id (boundary-validated), so it works from the
 * Workspace — which never populates the list slice — and never opens the modal
 * on a loosely-cast store row.
 */
export const showEditSchedulingWindow = async (args: ShowEditSchedulingWindowArgs): Promise<void> => {
  const createIn = args.mode === 'create' ? args.createIn : undefined;
  let data: FetchedSchedulingWindow | null = null;
  if (args.mode !== 'create') {
    data = await getSchedulingWindow(args.id);
    if (!data) {
      toast.error('Scheduling window not found; the list may be out of date. Please refresh.');
      return;
    }
  }
  await waitDialog<void>((ok) => <SchedulingWindowModal show handleClose={ok} mode={args.mode} data={data} createIn={createIn} />);
};
